import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  SimpleChanges,
} from '@angular/core';

import { FloorPlan } from '@shared/floor-plan/models';
import { FloorPlanForSwitcher } from '../canvas.constants';
import { AppIcon, AppIconColor, AppIconSize } from '@tablesready/frontend-icons';

@Component({
  selector: 'tablesready-floorplan-switcher',
  templateUrl: './floorplan-switcher.component.html',
  styleUrls: ['./floorplan-switcher.component.scss'],
})
export class FloorplanSwitcherComponent implements OnChanges {
  @Output() floorChange = new EventEmitter<string>();
  @Output() editPlan = new EventEmitter<FloorPlan>();
  @Input() items: FloorPlanForSwitcher[] = [];
  @Input() showEditButton = false;
  @Input() disabled = false;
  selectedItem?: FloorPlanForSwitcher;

  icon = AppIcon;
  iconSize = AppIconSize;
  iconColor = AppIconColor;
  expanded = false;

  select(id: string): void {
    this.expanded = false;
    const selectedItem = this.items.find(item => item.id === id);
    if (!selectedItem) {
      return;
    }

    if ((selectedItem.id === this.selectedItem?.id && selectedItem.name === this.selectedItem.name)) {
      this.selectedItem = selectedItem;
      return;
    }

    this.selectedItem = selectedItem;
    this.floorChange.emit(selectedItem.id);
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['items'] && this.items?.length === 1) {
      this.select(this.items[0].id);
    } else if (changes['items'] && this.items?.length > 1) {
      const defaultItem = this.items.find(item => item.default);
      if (!defaultItem) {
        this.select(this.items[0].id);
        return;
      }

      if (this.selectedItem !== undefined) {
        const selectedItem = this.items.find(item => item.id === this.selectedItem?.id);
        selectedItem !== undefined ? this.select(selectedItem.id) : this.select(defaultItem.id);
        return;
      }

      this.select(defaultItem.id);
    } else if (changes['items'] && this.items?.length === 0) {
      this.selectedItem = undefined;
    }
  }
}
